<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Labelorders") }}
        </div>
      </template>
      <div class="text-right">
        <!-- <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'labelorder.create' })"
        >
          {{ $t("create") }}
        </v-btn> -->
        <v-dialog
          v-model="suggestionDialog"
          scrollable
          persistent
          :overlay="false"
          transition="dialog-transition"
        >
          <v-card>
            <v-card-text>
              <v-switch
                :label="$t('suggest_all')"
                v-model="suggestAll"
              ></v-switch>

              <v-data-table
                :headers="suggestionHeaders"
                :items="computedOrderSuggestions"
                v-model="selectedOrderSuggestions"
                :options.sync="suggestionOptions"
                class="elevation-1"
                show-select
                item-key="uid"
                :loading="suggestionLoading"
                :footer-props="{
                  'items-per-page-options': [10, 15, 50, -1]
                }"
              >
                <template v-slot:item.label_type.name="{ item }">
                  {{ item.label_type.name
                  }}<v-icon
                    small
                    :title="
                      $t('Min stock quantity') +
                        ': ' +
                        item.label_type.stock_min +
                        ' | ' +
                        $t('Default order quantity') +
                        ':' +
                        item.label_type.default_order_quantity
                    "
                    >mdi-information-outline</v-icon
                  >
                </template>
                <template v-slot:item.qty="{ item }">
                  <v-text-field
                    name="qty"
                    label="Qty"
                    v-model="item.qty"
                    @change="item.to = Number(item.from) + Number(item.qty) - 1"
                    type="number"
                  ></v-text-field>
                </template>
              </v-data-table>
            </v-card-text>

            <v-card-actions>
              <v-btn
                class="ma-1"
                color="primary"
                :disabled="suggestionLoading"
                @click="closeSuggestionDialog"
              >
                {{ $t("close") }}
              </v-btn>
              <v-btn
                class="ma-1"
                color="primary"
                :loading="suggestionSaving"
                :disabled="
                  suggestionLoading || !selectedOrderSuggestions.length
                "
                @click="createSuggestedOrders"
              >
                {{ $t("create") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          class="ma-1"
          color="primary"
          :disabled="!selected.length"
          @click="printSelected"
        >
          {{ $t("print") }}
        </v-btn>
        <v-btn class="ma-1" color="primary" @click="openSuggestionDialog">
          {{ $t("ordersuggestion") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-data-table
        :headers="headers"
        :items="items"
        v-model="selected"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        show-select
        item-key="id"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.action="{ item }">
          <v-icon v-if="item.in_stock" small @click="setInStock(item)">
            mdi-truck
          </v-icon>
          <v-icon v-if="item.in_stock" small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{
            item.created_at ? moment(item.created_at).format("DD.MM.YYYY") : "-"
          }}
        </template>
      </v-data-table>
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import {
  fetchItems,
  deleteItem,
  fetchSuggestion,
  saveItem,
  setInStock
} from "../shared/services";
import { persistentTableOptions } from "../../../plugins/mixins";

export default {
  name: "app-labelorder-list",
  mixins: [persistentTableOptions],
  data() {
    return {
      loading: true,
      options: {
        itemsPerPage: 50
      },
      total: 0,
      search: "",
      items: [],
      selected: [],
      suggestionDialog: false,
      suggestionLoading: false,
      suggestionSaving: false,
      suggestionOptions: {
        itemsPerPage: 50
      },
      orderSuggestions: [],
      selectedOrderSuggestions: [],
      suggestAll: false
    };
  },

  computed: {
    computedOrderSuggestions() {
      if (!this.suggestAll) {
        return this.orderSuggestions.filter(
          sug =>
            sug.label_type.qty_on_stock < sug.label_type.stock_min ||
            sug.label_type.qty_on_stock < 0
        );
      } else {
        return this.orderSuggestions;
      }
    },
    headers() {
      return [
        {
          text: this.$t("Date"),
          value: "created_at"
        },
        {
          text: this.$t("number_range"),
          value: "number_range.name"
        },
        {
          text: this.$t("label_type"),
          value: "label_type.name"
        },
        {
          text: this.$t("from"),
          value: "from"
        },
        {
          text: this.$t("to"),
          value: "to"
        },
        {
          text: this.$t("Member"),
          value: "company.name"
        },
        { text: "", value: "action", sortable: false }
      ];
    },
    suggestionHeaders() {
      return [
        {
          text: this.$t("label_type"),
          value: "label_type.name"
        },
        {
          text: this.$t("number_range"),
          value: "number_range.name"
        },
        {
          text: this.$t("from"),
          value: "from"
        },
        {
          text: this.$t("to"),
          value: "to"
        },
        {
          text: this.$t("qty"),
          value: "qty"
        },

        {
          text: "in Aufträgen zu verschicken",
          value: "label_type.qty_on_sales_order"
        },
        {
          text: "im Lager",
          value: "label_type.qty_on_stock"
        },
        {
          text: "bestellt",
          value: "label_type.qty_on_label_order"
        },
        {
          text: this.$t("Company"),
          value: "company.name"
        }
      ];
    }
  },

  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems({ ...this.options, search: this.search });
      this.items = response.data;
      this.total = response.meta.total;
      this.selected = [];
      this.loading = false;
      this.itemsPerPage = 50;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("delete_labelorder")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async setInStock(item) {
      if (
        await this.$root.$confirm(
          this.$t("warehouse"),
          this.$t("warehouse_entry")
        )
      ) {
        let resp = await setInStock(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "labelorder.edit", params: { id: url } });
    },
    async fetchSuggestion() {
      let res = await fetchSuggestion();
    },
    closeSuggestionDialog() {
      this.getData();
      this.orderSuggestions = [];
      this.selectedOrderSuggestions = [];
      this.suggestionLoading = false;
      this.suggestionSaving = false;
      this.suggestionDialog = false;
    },
    async openSuggestionDialog() {
      this.orderSuggestions = [];
      this.selectedOrderSuggestions = [];
      this.suggestionLoading = true;
      this.suggestionDialog = true;
      try {
        const res = await fetchSuggestion();
        this.orderSuggestions = res.data.map((item, index) => ({
          uid: index,
          qty: item.to - item.from + 1,
          ...item
        }));
      } finally {
        this.suggestionLoading = false;
      }
    },
    async createSuggestedOrders() {
      this.suggestionSaving = true;
      try {
        await Promise.all(
          this.selectedOrderSuggestions.map(orderSuggestion =>
            saveItem(null, orderSuggestion, null)
          )
        );
        this.closeSuggestionDialog();
      } finally {
        this.suggestionSaving = false;
      }
    },
    printSelected() {
      if (!this.selected.length) {
        this.$notification(this.$t("select_data"), { type: "error" });
        return;
      }
      const ids = this.selected.map(item => item.id).join(",");
      const url = this.$options.filters.addToken(
        `/labelorders/print?ids=${ids}`
      );
      window.open(url, "_blank");
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
